import { getState, isInitialized, setState } from './state'

/**
 * Initialize the fingerprint collector.
 *
 * Idempotent — subsequent calls after the first are no-ops. Safe to invoke
 * once per page load (recommended) or defensively from multiple entry points.
 *
 * Phase 1 behavior:
 *   1. Honors `?noFingerprint=1` URL flag for debug/QA opt-out.
 *
 * Consent is NOT gated here — the 15 Phase 1 signals are the same data GA4
 * already collects under the existing user consent. The consumer (auth-core)
 * decides whether to call `init()` based on its own consent context. Phase 2,
 * which adds Tier 1/2 enrichers (canvas/WebGL/audio), will introduce a
 * consent argument here.
 *
 * Future phases will add: composite hash, Tier 1/2 enrichers, Web Worker
 * delegation, cookie/header delivery helpers.
 */
export function init(): void {
  if (isInitialized()) return

  setState({
    disabled: isDebugDisabled(),
    initializedAt: Date.now(),
  })
}

function isDebugDisabled(): boolean {
  if (typeof window === 'undefined') return false
  try {
    const params = new URLSearchParams(window.location.search)
    return params.get('noFingerprint') === '1'
  } catch {
    return false
  }
}

/**
 * Internal: read whether the collector is currently disabled (debug flag).
 * Used by `get` to decide whether to compose signals.
 */
export function isDisabled(): boolean {
  const state = getState()
  return state?.disabled ?? false
}
